export const fillEmptyDivs = () => {
    document.querySelectorAll('div:empty').forEach((div) => {
        div.innerHTML = '<span></span>';
    });
};

export default { fillEmptyDivs };
